@if (processes()?.length) {
  @for (process of processes(); track $index) {
    @if (process.data[0] > 0 || process.categoryId <= ECalculusStateFilter.total) {
      <button
        [style.flex]="process.categoryId > ECalculusStateFilter.total ? '0.3' : 1"
        [ngClass]="{
          active: isCategorySelected(process.categoryId),
          inactive: !isCategorySelected(process.categoryId),
        }"
        (click)="onProcessClick(process.categoryId)">
        @if (process.categoryId === ECalculusStateFilter.onHold) {
          <label class="process-header-label">
            <mat-icon [svgIcon]="EsvgFiles.hourglass"/>
          </label>

          <kpi4me-evaluation-on-hold
            [process]="process"
            [evaluationData]="process.data"
            (barClicked)="onBarClicked($event, process.categoryId)"
          />
        } @else if (process.categoryId === ECalculusStateFilter.clientAccessMessages) {
          <label class="process-header-label">
            <mat-icon [svgIcon]="EsvgFiles.user"/>
          </label>

          <kpi4me-evaluation-client-access
            [process]="process"
            [evaluationData]="process.data"
            (barClicked)="onBarClicked($event, process.categoryId)"
          />
        } @else if (process.categoryId === ECalculusStateFilter.uncollectible) {
          <label class="process-header-label">
            <mat-icon [svgIcon]="EsvgFiles.search"/>
          </label>

          <kpi4me-evaluation-client-access
            [process]="process"
            [evaluationData]="process.data"
            (barClicked)="onBarClicked($event, process.categoryId)"
          />
        } @else {
          <label class="process-header-label">
            {{ process.label }}
          </label>

          <kpi4me-evaluation
            [process]="process"
            [evaluationData]="process.data"
            (barClicked)="onBarClicked($event, process.categoryId)"
          />
        }
      </button>
    }
  }

  <!--  <lib-help-icon (click)="showHelpForEvaluation()"/>-->
}
